var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGif({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e9e0",
    d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e57e25",
    fillOpacity: 1,
    d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d9d7ca",
    points: "37.5,0.151 37.5,12 49.349,12"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#f3d55b",
    cx: 18.931,
    cy: 14.431,
    r: 4.569
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f29c1f",
    fillOpacity: 1,
    points: "6.5,39 17.5,39 49.5,39 49.5,28 39.5,18.5 29,30 23.517,24.517"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.99024353,1.0098526)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 25.597767,47.327931 0,3.864609 q -0.311881,0.393241 -0.705122,0.650882 -0.379681,0.24408 -0.813602,0.406801 -0.420361,0.16272 -0.881402,0.23052 -0.447481,0.0678 -0.894962,0.0678 -0.894962,0 -1.654324,-0.325441 -0.745802,-0.325441 -1.315323,-0.962763 -0.555962,-0.637321 -0.881402,-1.600083 -0.311881,-0.962763 -0.311881,-2.223846 0,-1.261083 0.311881,-2.210285 0.32544,-0.962762 0.881402,-1.600084 0.569521,-0.637321 1.328883,-0.962762 0.759362,-0.339001 1.640764,-0.339001 0.813602,0 1.518723,0.271201 0.705122,0.2712 1.261083,0.813602 l -1.125482,1.003442 q -0.325441,-0.393241 -0.745802,-0.569521 -0.420361,-0.176281 -0.867842,-0.176281 -0.501721,0 -0.962762,0.189841 -0.447482,0.18984 -0.813602,0.650881 -0.352561,0.447481 -0.555962,1.166163 -0.2034,0.718682 -0.21696,1.762804 0.01356,1.017003 0.2034,1.762805 0.203401,0.745801 0.542402,1.220402 0.35256,0.474602 0.786481,0.705122 0.447482,0.230521 0.935643,0.230521 0.14916,0 0.393241,-0.01356 0.25764,-0.02712 0.501721,-0.0678 0.25764,-0.05424 0.488161,-0.135601 0.230521,-0.08136 0.339001,-0.23052 l 0,-2.467926 -1.695004,0 0,-1.111923 3.308648,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 29.625096,52.480743 -1.654324,0 0,-9.993744 1.654324,0 0,9.993744 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.815146,43.720962 0,3.145928 4.17649,0 0,1.111923 -4.17649,0 0,4.50193 -1.654324,0 0,-9.993744 6.251175,0 0,1.233963 -4.596851,0 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGif);
export default __webpack_public_path__ + "static/media/gif.69d98eaeb1f86eb4d563d3a56c276a5d.svg";
export { ForwardRef as ReactComponent };